/* Cosana Certificate of Analysis page interactions
   - Index search filter
   - Flip card click + cursor tilt
   - Meter fill animation on intersection
   - Share link copy-to-clipboard
   No external dependencies. ~150 lines. */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // -----------------------
  // View switching (?batch=<id>)
  // -----------------------
  var detailViewsContainer = document.querySelector('[data-cert-detail-views]');
  var heroIndex = document.querySelector('.cert-index-hero');
  var indexList = document.querySelector('[data-cert-index-list]');

  var showView = function (batchId) {
    var allDetails = document.querySelectorAll('[data-cert-detail]');
    if (batchId) {
      var match = document.querySelector('[data-cert-detail="' + batchId.toLowerCase() + '"]');
      if (match) {
        if (heroIndex) heroIndex.setAttribute('hidden', '');
        if (indexList) indexList.setAttribute('hidden', '');
        if (detailViewsContainer) detailViewsContainer.removeAttribute('hidden');
        allDetails.forEach(function (el) { el.setAttribute('hidden', ''); });
        match.removeAttribute('hidden');
        document.title = batchId.toUpperCase() + ' — ' + document.title.replace(/^[^—]*— /, '');
        return true;
      }
    }
    // Default: index visible, all details hidden
    if (heroIndex) heroIndex.removeAttribute('hidden');
    if (indexList) indexList.removeAttribute('hidden');
    if (detailViewsContainer) detailViewsContainer.setAttribute('hidden', '');
    allDetails.forEach(function (el) { el.setAttribute('hidden', ''); });
    return false;
  };

  var getBatchFromUrl = function () {
    var params = new URLSearchParams(window.location.search);
    return params.get('batch');
  };

  // Initial render
  showView(getBatchFromUrl());

  // Hook row clicks: pushState instead of full navigate
  document.querySelectorAll('[data-cert-row]').forEach(function (row) {
    row.addEventListener('click', function (e) {
      var id = row.getAttribute('data-cert-batch-id');
      if (!id) return;
      e.preventDefault();
      var url = window.location.pathname + '?batch=' + id;
      window.history.pushState({ batch: id }, '', url);
      showView(id);
      window.scrollTo(0, 0);
    });
  });

  // Browser back/forward
  window.addEventListener('popstate', function () {
    showView(getBatchFromUrl());
    window.scrollTo(0, 0);
  });

  // -----------------------
  // Search filter (index)
  // -----------------------
  var searchInput = document.querySelector('[data-cert-search]');
  if (searchInput) {
    var rows = document.querySelectorAll('[data-cert-row]');
    var tiers = document.querySelectorAll('[data-cert-tier]');
    var emptyEl = document.querySelector('[data-cert-empty]');
    var emptyMsg = document.querySelector('[data-cert-empty-message]');

    var filter = function () {
      var q = (searchInput.value || '').trim().toLowerCase();
      var anyVisible = false;

      rows.forEach(function (row) {
        var id = row.getAttribute('data-cert-batch-id') || '';
        var match = !q || id.indexOf(q) !== -1;
        row.style.display = match ? '' : 'none';
        if (match) anyVisible = true;
      });

      tiers.forEach(function (tier) {
        var visibleRows = tier.querySelectorAll('[data-cert-row]:not([style*="display: none"])');
        var countEl = tier.querySelector('[data-cert-tier-count]');
        var labelEl = tier.querySelector('[data-cert-tier-label]');
        if (visibleRows.length === 0) {
          tier.style.display = 'none';
        } else {
          tier.style.display = '';
          if (countEl) countEl.textContent = visibleRows.length;
          if (labelEl) {
            var labelOne = labelEl.getAttribute('data-label-one') || '';
            var labelOther = labelEl.getAttribute('data-label-other') || '';
            labelEl.textContent = visibleRows.length === 1 ? labelOne : labelOther;
          }
        }
      });

      if (emptyEl) {
        if (!anyVisible && q) {
          if (emptyMsg) emptyMsg.textContent = emptyMsg.getAttribute('data-template')
            ? emptyMsg.getAttribute('data-template').replace('{query}', q)
            : 'Keine Charge gefunden.';
          emptyEl.removeAttribute('hidden');
        } else {
          emptyEl.setAttribute('hidden', '');
        }
      }
    };

    searchInput.addEventListener('input', filter);
  }

  // -----------------------
  // Flip card (every batch detail block has its own)
  // -----------------------
  var isDesktop = window.matchMedia('(min-width: 769px)').matches;

  document.querySelectorAll('[data-flip-card]').forEach(function (card) {
    var inner = card.querySelector('[data-flip-card-inner]');
    var hint = card.querySelector('[data-flip-card-hint]');
    var flipped = false;

    var setHint = function () {
      if (!hint) return;
      var labels = window.CERT_I18N || {};
      hint.textContent = flipped
        ? (labels.showFront || 'Tap — front')
        : (labels.showBack || 'Tap — all parameters');
    };

    var setAria = function () {
      var labels = window.CERT_I18N || {};
      card.setAttribute('aria-label', flipped
        ? (labels.ariaFront || labels.showFront || 'Show front')
        : (labels.ariaBack || labels.showBack || 'Show back'));
      card.setAttribute('aria-pressed', flipped ? 'true' : 'false');
    };

    var toggle = function () {
      flipped = !flipped;
      card.classList.toggle('is-flipped', flipped);
      setHint();
      setAria();
    };

    card.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a, button')) return;
      toggle();
    });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (e.target && e.target.closest && e.target.closest('a, button')) return;
        e.preventDefault();
        toggle();
      }
    });

    if (isDesktop && !prefersReducedMotion && inner) {
      var raf = null;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        var tiltX = (0.5 - y) * 6;
        var tiltY = (x - 0.5) * 8;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var flipDeg = flipped ? 180 : 0;
          inner.style.transform = 'rotateX(' + tiltX + 'deg) rotateY(' + (tiltY + flipDeg) + 'deg)';
        });
      });
      card.addEventListener('mouseleave', function () {
        var flipDeg = flipped ? 180 : 0;
        inner.style.transform = 'rotateX(0deg) rotateY(' + flipDeg + 'deg)';
      });
    }
  });

  // -----------------------
  // Meter fill on intersection
  // -----------------------
  var meters = document.querySelectorAll('[data-meter]');
  if (meters.length && 'IntersectionObserver' in window && !prefersReducedMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    meters.forEach(function (m) { io.observe(m); });
  } else {
    // Fallback — show all meters in their final state
    meters.forEach(function (m) { m.classList.add('is-visible'); });
  }

  // -----------------------
  // Share button
  // -----------------------
  var shareBtn = document.querySelector('[data-cert-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = shareBtn.getAttribute('data-share-url') || window.location.href;
      var title = document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () { /* ignored */ });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          var original = shareBtn.textContent;
          shareBtn.textContent = (window.CERT_I18N && window.CERT_I18N.copied) || 'Copied ✓';
          setTimeout(function () { shareBtn.textContent = original; }, 1800);
        });
      }
    });
  }
})();
